/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_TextInputs */

const en_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Event Text`)
};

const fr_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le texte de l'événement`)
};

const de_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext kopieren`)
};

const it_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia testo evento`)
};

const ru_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать текст события`)
};

const es_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto del evento`)
};

const zh_cn2_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制事件文本`)
};

const ja_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストをコピー`)
};

const hi_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट कॉपी करें`)
};

const pt_pt2_copy_event_text = /** @type {(inputs: Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto do evento`)
};

/**
* | output |
* | --- |
* | "Copy Event Text" |
*
* @param {Copy_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text = /** @type {((inputs?: Copy_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_event_text(inputs)
	if (locale === "de") return de_copy_event_text(inputs)
	if (locale === "it") return it_copy_event_text(inputs)
	if (locale === "ru") return ru_copy_event_text(inputs)
	if (locale === "es") return es_copy_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_event_text(inputs)
	if (locale === "ja") return ja_copy_event_text(inputs)
	if (locale === "hi") return hi_copy_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_event_text(inputs)
	return en_copy_event_text(inputs)
});